import { BaseAPI } from '../manager/base';
import apiClient from '../apiClient';
import type { BaseResponse, ListResponse, PaginationRequest } from '../../types/base.dto';
import type { PurchaseInfo } from '../../types/process/purchase';

/**
 * 采购单API服务类
 */
export class PurchaseAPI extends BaseAPI<PurchaseInfo> {
  constructor() {
    super('/purchases');
  }

  /**
   * 获取采购单列表 (带场景支持)
   */
  async list(params: PaginationRequest & { scene?: string }): Promise<BaseResponse<ListResponse<PurchaseInfo>>> {
    const response = await apiClient.post<BaseResponse<ListResponse<PurchaseInfo>>>(`${this.endpoint}/list`, params);
    return response.data;
  }

  /**
   * 采购单状态动作（统一入口）
   */
  async changeStatus(id: string, action: string, params?: Record<string, any>): Promise<BaseResponse<any>> {
    const response = await apiClient.post<BaseResponse<any>>(`${this.endpoint}/${id}/actions`, {
      action,
      params: params || {}
    });
    return response.data;
  }

  /**
   * 批量采购单状态变更
   */
  async batchChangeStatus(purchaseNos: string[], action: string, params?: Record<string, any>): Promise<BaseResponse<any>> {
    const response = await apiClient.post<BaseResponse<any>>(`${this.endpoint}/batch/actions`, {
      purchaseNos,
      action,
      params: params || {}
    });
    return response.data;
  }

  /**
   * 获取采购单统计（KPI + Tabs）
   */
  async getStats(sceneGroup: string, params?: Record<string, any>): Promise<StatsResponseItem[]> {
    const response = await apiClient.post<BaseResponse<StatsResponseItem[]>>(`${this.endpoint}/stats`, {
      scene: sceneGroup,
      ...(params || {})
    });
    return response.data.data;
  }

  /**
   * 导出采购单
   */
  async export(params: Record<string, any>): Promise<BaseResponse<any>> {
    const response = await apiClient.post<BaseResponse<any>>(`${this.endpoint}/export`, params);
    return response.data;
  }

}

export interface StatsResponseItem {
  key: string;
  label: string;
  value: number;
}

export const purchaseApi = new PurchaseAPI();
export default purchaseApi;
